import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayersTwo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayersTwo"><Path d="M5.41669 12.7493L1.21094 15.0938L12.0013 21.1087L22.7917 15.0938L18.5859 12.7493L12.0013 16.4198L5.41669 12.7493Z" fill="currentColor"/><Path d="M12.0013 2.89136L1.21094 8.90626L12.0013 14.9212L22.7917 8.90626L12.0013 2.89136Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayersTwo;
